export async function getAutocompleteAddress(
  input: string,
): Promise<google.maps.places.AutocompletePrediction[]> {
  if (!input.trim()) {
    return Promise.resolve([])
  }

  const autocomplete = new google.maps.places.AutocompleteService()

  return new Promise((resolve, reject) => {
    autocomplete.getPlacePredictions(
      {
        input,
        types: ['(cities)'],
      },
      (result, status) => {
        if (status === 'OK') {
          resolve(result)
        } else {
          reject(new Error(status))
        }
      },
    )
  })
}
